import React from 'react';
// import {RoutePermittedRole} from '@crema/constants/AppEnums';
import {TbDeviceDesktopAnalytics} from 'react-icons/tb';
import {BiSolidCategoryAlt} from 'react-icons/bi';
import {
  MdOutlineStorefront,
  MdOutlineSettings,
  MdOutlineSubscriptions,
  MdNotificationsActive,
  MdMiscellaneousServices,
} from 'react-icons/md';
import {BsCalendarCheck} from 'react-icons/bs';
import {MdPayment} from 'react-icons/md';
import {FiUsers} from 'react-icons/fi';

const routesConfig = [
  {
    id: 'home',
    title: 'Home',
    messageId: 'Home',
    type: 'item',
    icon: <TbDeviceDesktopAnalytics />,
    url: '/Home',
  },
  {
    id: 'users',
    title: 'Users',
    messageId: 'Users',
    type: 'item',
    icon: <FiUsers />,
    url: '/users',
  },
  {
    id: 'businesses',
    title: 'Businesses',
    messageId: 'Businesses',
    type: 'collapse',
    icon: <MdOutlineStorefront />,
    children: [
      {
        id: 'all-businesses',
        title: 'All Businesses',
        messageId: 'All Businesses',
        type: 'item',
        url: '/businesses/all',
      },
      {
        id: 'pending-businesses',
        title: 'Pending Approvals',
        messageId: 'Pending Approvals',
        type: 'item',
        url: '/businesses/pending',
      },
      {
        id: 'rejected-businesses',
        title: 'Rejected',
        messageId: 'Rejected',
        type: 'item',
        url: '/businesses/rejected',
      },
    ],
  },
  {
    id: 'categories',
    title: 'Categories',
    messageId: 'Categories',
    type: 'item',
    icon: <BiSolidCategoryAlt />,
    url: '/categories',
  },
  {
    id: 'services',
    title: 'Services',
    messageId: 'Services',
    type: 'item',
    icon: <MdMiscellaneousServices />,
    url: '/services',
  },
  {
    id: 'bookings',
    title: 'Bookings',
    messageId: 'Bookings',
    type: 'item',
    icon: <BsCalendarCheck />,
    url: '/bookings',
  },
  {
    id: 'payments',
    title: 'Payments',
    messageId: 'Payments',
    type: 'item',
    icon: <MdPayment />,
    url: '/payments',
  },
  {
    id: 'subscriptions',
    title: 'Subscriptions',
    messageId: 'Subscriptions',
    type: 'item',
    icon: <MdOutlineSubscriptions />,
    url: '/subscriptions',
  },
  {
    id: 'notifications',
    title: 'Notifications',
    messageId: 'Notifications',
    type: 'item',
    icon: <MdNotificationsActive />,
    url: '/notifications/send',
  },
  {
    id: 'settings',
    title: 'Settings',
    messageId: 'Settings',
    type: 'item',
    icon: <MdOutlineSettings />,
    url: '/settings',
  },
];
export default routesConfig;
